import React from 'react';
import LocalImage from "./LocalImage/LocalImage";
import CdnImage from "./CdnImage/CdnImage";
import HttpImage from "./HttpImage/HttpImage";

export type ServerType = 'LOCAL' | 'CDN' | 'HTTP'

interface IProps {
    src: string;
    imageServer?: ServerType;
    alt?: string;
    width?: string;
    height?: string;
    style?:object,
    className?:string,
    showLoading?: boolean;
    showNotFoundImage?: boolean;
    [key: string]: any,
}

const AppImage: React.FC<IProps> = props => {
    const { src, imageServer = 'LOCAL', ...restProps } = props;

    if (imageServer === 'CDN') {
        return <CdnImage imageId={src} {...restProps}/>
    }
    else if (imageServer === 'HTTP') {
        return <HttpImage src={src} {...restProps}/>
    }
    else {
        return <LocalImage src={src} {...restProps}/>
    }
}

export default React.memo(AppImage);